<template>
  <div>
    <vs-alert class="mt-2">
      <p>Complete este formulario solo si el pago a la escuela se realizó en varias transacciones. Estos valores no suman al pago principal.
        Registre cada monto y detalle correspondiente.</p>
    </vs-alert>
    <p class="mt-2 text-2xl">
      <b>Total Detalle:</b> {{ totalValor }}
    </p>
    <div class="mt-5">
      <vs-button icon="add" class="mb-2 p-3" @click="f_limpiar();title='Agregar detalle de pago';popupAdd=true;">Crear</vs-button>
    </div>
    <vs-table max-items="5" search pagination :data="arrayDetallesPagos">
      <template slot="header">
          <vs-chip  color="primary">Cantidad: <b> {{ arrayDetallesPagos.length }}</b></vs-chip>
      </template>
      <template slot="thead">
          <vs-th>Valor</vs-th>
          <vs-th>descripción</vs-th>
          <vs-th>Acciones</vs-th>
      </template>
      <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                  <p><b>Valor:</b> {{ tr.valor }}</p>
                  <b class="mt-2">Fecha creación</b>
                  <p>{{ tr.created_at }}</p>
                  <b>Creador:</b>
                  <p>{{ tr.usuario_creador }}</p>
                  <b v-if="tr.usuario_editor">Último Editor:</b>
                  <p v-if="tr.usuario_editor">{{ tr.usuario_editor }}</p>
              </vs-td>
              <vs-td>
                  {{data[indextr].descripcion}}<br>
              </vs-td>
              <vs-td align="center">
                <!--boton editar-->
                <vs-button class="m-2" size="small" @click="DetalleSelected=tr;f_preEditar();" icon-pack="feather" icon="icon-edit">Editar</vs-button>
                <!--boton eliminar-->
                <vs-button class="m-2" size="small" color="danger" @click="DetalleSelected=tr;popupConfirmDelete=true;" type="filled" icon-pack="feather" icon="icon-x-square"> Eliminar</vs-button>
              </vs-td>
          </vs-tr>
      </template>
    </vs-table>
    <!--modal para crear detalle pago-->
    <vs-popup classContent="popup-example" :title="title" :active.sync="popupAdd" class="informacionformhijo">
      <div v-if="popupAdd">
        <div class="vx-row">
          <div class="vx-col w-full">
            <small>Valor:</small>
            <vs-input v-model="datos.valor" class="w-full" @input="datos.valor = limpiarValorNumerico(datos.valor)"></vs-input>
          </div>
          <div class="vx-col w-full mt-5">
            <small>descripción:</small>
            <vs-textarea  counter="500" :counter-danger.sync="counterDanger" height="200px" label="Observación" v-model="datos.descripcion" />
          </div>
        </div>
        <div class="flex justify-center mt-5">
          <vs-button @click="f_guardarDetalle()" class="m-2" icon="check">Guardar</vs-button>
          <vs-button @click="popupAdd=false" type="border"  color="warning" class="m-2" icon="close">Cancelar</vs-button>
        </div>
      </div>
    </vs-popup>
    <!--MODAL PARA CONFIRM ELIMINAR-->
    <vs-popup classContent="popup-example" title="Eliminar" :active.sync="popupConfirmDelete" class="informacionformhijo">
      <div v-if="popupConfirmDelete">
        <p class="text-center font-bold text-2xl">Estas seguro de eliminar?</p>
        <div class="flex justify-center mt-5">
          <vs-button @click="f_eliminarDetalle()" class="m-2" icon="check">Si, deseo eliminar</vs-button>
          <vs-button @click="popupConfirmDelete=false" type="border"  color="warning" class="m-2" icon="close">Cancelar</vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import Generalmix from '../../../../../../mixins/Generalmix'

export default{
  mixins:[Generalmix],
  data(){
    return{
      usuario:[],
      arrayDetallesPagos: [],
      popupAdd: false,
      popupConfirmDelete: false,
      id: 0,
      datos:{
        valor:0,
        descripcion:'',
      },
      DetalleSelected:'',
      title:'Agregar detalle de pago',
      counterDanger: false,
    }
  },
  props:{
    id_pago:{
      type: Number,
      default: 0
    },
  },
  mounted(){
    let me = this
    me.usuario = JSON.parse(localStorage.getItem('usuario'))
    me.f_getDetallesPago()
  },
  computed:{
    totalValor(){
      let me = this
      let total = 0
      if(me.arrayDetallesPagos.length > 0){
        me.arrayDetallesPagos.forEach(function (item) {
          total += Number(item.valor)
        })
      }
      return total
    },
  },
  methods:{
    validarValor(event) {
      let valor = event;
      // Si contiene letras, reemplaza todo por "0"
      if (/[^0-9.]/.test(valor)) {
        this.datos.valor = "0";
      } else {
        this.datos.valor = valor;
      }
    },
    f_getDetallesPago(){
      let me = this
      me.arrayDetallesPagos = []
      me.$http.get(me.$server_url + `pedigo_Pagos?getSubPagos=1&doc_codigo=${ me.id_pago }`)
      .then(function (res) {
        if(res.data.status == 0){
          me.m_message(res.data.message,'error')
          return
        }
        if(res.data.length == 0){
          me.m_message('No hay detalles de pagos para mostrar','warning')
          return
        }
        me.arrayDetallesPagos = res.data
      })
      .catch(function (error) {
        console.log(error);
      });
    },
    f_preEditar(){
      let me = this
      me.id                 = me.DetalleSelected.id_pedido_pago_detalle
      me.datos.valor        = me.DetalleSelected.valor
      me.datos.descripcion  = me.DetalleSelected.descripcion
      me.title              = 'Editar detalle de pago'
      me.popupAdd           = true
    },
    f_guardarDetalle(){
      let me = this
      if(me.datos.valor < 0){
        me.m_message('El valor no puede ser 0','warning')
        return
      }
      me.datos.descripcion = me.datos.descripcion.trim()
      if(me.datos.descripcion == ''){
        me.m_message('La descripción no puede estar vacía','warning')
        return
      }
      // trim para quitar espacios en blanco al inicio y al final

      //maximo 500 caracteres
      if(me.datos.descripcion.length > 500){
        me.m_message('La descripción no puede tener más de 500 caracteres','warning')
        return
      }
      let formData = new FormData()
      formData.append('saveDetallePago', 1)
      formData.append('id', me.id)
      formData.append('id_usuario',     me.usuario.idusuario)
      formData.append('id_pago',        me.id_pago)
      formData.append('valor',          me.datos.valor)
      formData.append('descripcion',    me.datos.descripcion)
      me.$http.post(me.$server_url + `pedigo_Pagos`, formData)
      .then(function (res) {
        if(res.data.status == 0){
          me.m_message(res.data.message,'warning')
          return
        }
        me.popupAdd = false
        me.f_getDetallesPago()
        me.m_message('Detalle de pago creado con éxito','success')
        me.f_limpiar()
      })
      .catch(function (error) {
        me.popupAdd = false
        me.m_message('Error al crear el detalle de pago','warning')
        console.log(error);
      });
    },
    f_eliminarDetalle(){
      let me = this
      let formData = new FormData()
      formData.append('eliminarDetallePago', 1)
      formData.append('id', me.DetalleSelected.id_pedido_pago_detalle)
      formData.append('id_usuario', me.usuario.idusuario)
      me.$http.post(me.$server_url + `pedigo_Pagos`, formData)
      .then(function (res) {
        if(res.data.status == 0){
          me.m_message(res.data.message,'warning')
          return
        }
        me.popupConfirmDelete = false
        me.f_getDetallesPago()
        me.m_message('Detalle de pago eliminado con éxito','success')
      })
      .catch(function (error) {
        me.popupConfirmDelete = false
        me.m_message('Error al eliminar el detalle de pago','warning')
        console.log(error);
      });
    },
    f_limpiar(){
      let me = this
      me.id = 0
      me.datos.valor = 0
      me.datos.descripcion = ''
    }
  },
}
</script>
<style scoped>
.informacionformhijo {
    z-index: 51002;
    /* Asegúrate de que este valor sea alto para que el popup hijo del hijo pueda superponerse */
    /* position: fixed; */
    /* Asegúrate de que la posición sea adecuada */
}
</style>

